import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Lore from "../views/Lore.vue";
import Toc from "../views/Toc.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/lore",
    name: "Lore",
    component: Lore,
  },
  {
    path: "/toc",
    name: "Toc",
    component: Toc,
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
